export const ProductRestrictionType = {
  NO_RESTRICTION: "no-restriction",
  CATEGORIES: "categories",
  PRODUCTS: "products",
} as const;

export type ProductRestrictionType =
  typeof ProductRestrictionType[keyof typeof ProductRestrictionType];

export default ProductRestrictionType;
